import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {TranslocoModule} from '@ngneat/transloco';
import {ConfirmButtonModule} from '@shared/controls/confirm-button/confirm-button.module';
import {faTrash} from '@fortawesome/pro-solid-svg-icons/faTrash';

@Component({
  selector: 'pl-data-set-input-row-delete-button',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslocoModule, ConfirmButtonModule],
  templateUrl: './data-set-input-row-delete-button.component.html',
  styleUrls: ['./data-set-input-row-delete-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataSetInputRowDeleteButtonComponent {

  constructor(faIconLibrary: FaIconLibrary) {
    faIconLibrary.addIcons(faTrash);
  }

  @Output() deleteRow = new EventEmitter<void>();

}
